import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';

import { CmsModule } from '@fcom/cms';
import { LocalizationProvider } from '@fcom/core/services/language/localization.provider';
import { I18nKey } from '@fcom/core';
import { CorporateService } from '@fcom/common/services/corporate/corporate.service';
import { BookingWidgetModule } from '@fcom/booking-widget/booking-widget.module';
import { COMMON_BOOKING_FEATURE_KEY, reducers } from '@fcom/common-booking';
import { ComponentsModule, NavigationModule } from '@fcom/common/components';
import { UiTranslateModule } from '@fcom/ui-translate/ui-translate.module';
import { UiComponentsModule } from '@fcom/ui-components/ui-components.module';
import { PipesModule } from '@fcom/common/pipes';
import { CommonServiceFormsModule } from '@fcom/service-forms/components/common/common-service-forms.module';
import { DirectiveModule } from '@fcom/common/directives';
import { BookingModule } from '@fcom/booking/booking.module';
import { MmbOrderModule } from '@fcom/manage-booking-common/mmb-order.module';

import { CorporateRoutesModule } from './corporate.routes';
import { CorporateRoutingComponent } from './components/corporate-routing/corporate-routing.component';
import { TripsViewComponent } from './components/trips-view/trips-view.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { PersonalDetailsFormComponent } from './components/forms/personal-details-form/personal-details-form.component';
import { PassportDetailsFormComponent } from './components/forms/passport-details-form/passport-details-form.component';
import { UserDetailsFormComponent } from './components/forms/user-details-form/user-details-form.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { CompanyDetailsComponent } from './components/company-details/company-details.component';
import { AddUserComponent } from './components/add-user/add-user.component';
import { CorporateQuickLinksComponent } from './components/quick-links/quick-links.component';
import { CorporateHomeComponent } from './components/pages/corporate-home/corporate-home.component';
import { CorporateNavigationComponent } from './components/corporate-navigation/corporate-navigation.component';
import { CorporateHeroComponent } from './components/corporate-hero/corporate-hero.component';
import { CorporateTripsComponent } from './components/pages/corporate-trips/corporate-trips.component';
import { CorporateUsersComponent } from './components/pages/corporate-users/corporate-users.component';
import { CorporateCompanyComponent } from './components/pages/corporate-company/corporate-company.component';
import { ImageCardsComponent } from './components/image-cards/image-cards.component';
import { CorporateDataPageComponent } from './components/pages/corporate-spend/corporate-data-page.component';
import { CorporateDataComponent } from './components/corporate-data/corporate-data.component';
import { CorporateStoreModule } from './store/store.module';
import { RebookTripComponent } from './components/rebook-trip/rebook-trip.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { KpiComponent } from './components/kpi/kpi.component';
import { CorporateDataTableComponent } from './components/data-table/data-table.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { CorporateWidgetComponent } from './components/widgets/corporate-widget/corporate-widget.component';
import { NextTripsWidgetComponent } from './components/widgets/next-trips-widget/next-trips-widget.component';
import { ToggleButtonComponent } from './components/toggle-button/toggle-button.component';
import { ToggleButtonGroupComponent } from './components/toggle-button-group/toggle-button-group.component';
import { TextToggleButtonGroupComponent } from './components/text-toggle-button-group/text-toggle-button-group.component';
import { TextToggleButtonComponent } from './components/text-toggle-button/text-toggle-button.component';
import { YourNextTripWidgetComponent } from './components/widgets/your-next-trip-widget/your-next-trip-widget.component';
import { ChartLegendComponent } from './components/chart-legend/chart-legend.component';
import { CorporateBenefitsWidgetComponent } from './components/widgets/corporate-benefits-widget/corporate-benefits-widget.component';
import { SafWidgetComponent } from './components/widgets/saf-widget/saf-widget.component';
import { ChoooseRedirectorComponent } from './components/chooose-redirector/chooose-redirector.component';
import { SafTermsComponent } from './components/widgets/saf-widget/saf-terms.component';

@NgModule({
  imports: [
    CommonModule,
    CorporateRoutesModule,
    NavigationModule,
    ComponentsModule,
    CmsModule,
    UiTranslateModule,
    DirectiveModule,
    UiComponentsModule,
    PipesModule,
    CommonServiceFormsModule,
    MmbOrderModule,
    BookingModule,
    BookingWidgetModule,
    StoreModule.forFeature(COMMON_BOOKING_FEATURE_KEY, reducers),
    CorporateStoreModule,
  ],
  declarations: [
    CorporateRoutingComponent,
    UserListComponent,
    UserDetailsComponent,
    AddUserComponent,
    PersonalDetailsFormComponent,
    PassportDetailsFormComponent,
    UserDetailsFormComponent,
    CompanyDetailsComponent,
    TripsViewComponent,
    CorporateQuickLinksComponent,
    RebookTripComponent,
    CorporateHomeComponent,
    CorporateNavigationComponent,
    CorporateHeroComponent,
    CorporateTripsComponent,
    CorporateUsersComponent,
    CorporateCompanyComponent,
    CorporateDataPageComponent,
    CorporateDataComponent,
    ImageCardsComponent,
    LineChartComponent,
    BarChartComponent,
    KpiComponent,
    CorporateDataTableComponent,
    TooltipComponent,
    CorporateWidgetComponent,
    NextTripsWidgetComponent,
    ToggleButtonComponent,
    ToggleButtonGroupComponent,
    TextToggleButtonGroupComponent,
    TextToggleButtonComponent,
    YourNextTripWidgetComponent,
    ChartLegendComponent,
    CorporateBenefitsWidgetComponent,
    SafWidgetComponent,
    ChoooseRedirectorComponent,
    SafTermsComponent,
  ],
  providers: [CorporateService],
})
export class CorporateModule {
  constructor(private localizationProvider: LocalizationProvider) {
    this.localizationProvider.triggerLazyLocalizations(I18nKey.CORPORATE);
  }
}
